"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Dropdown_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Dropdown"));
var react_1 = require("react");
var Item_1 = __importDefault(require("../Item/Item"));
var ProfileIcon_1 = __importDefault(require("../ProfileIcon/ProfileIcon"));
/**
 * HCUI guidelines require a profile indicator to appear in the header of apps that require login. This is accomplished with the  `<Header.UserProfile />` component. This component either be a standalone element or contain child elements that will appear as dropdown items on hover of the profile icons.
 * @child ./Item/Item.tsx
 */
var UserProfile = /** @class */ (function (_super) {
    __extends(UserProfile, _super);
    function UserProfile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProfile.prototype.render = function () {
        var _a = this.props, firstName = _a.firstName, lastName = _a.lastName, role = _a.role, imageUrl = _a.imageUrl, rest = __rest(_a, ["firstName", "lastName", "role", "imageUrl"]);
        if (this.props.children) {
            return (React.createElement(Dropdown_1.default, __assign({}, rest, { className: "user-profile-menu", item: true, simple: true, direction: "right", icon: "", trigger: React.createElement(ProfileIcon_1.default, { firstName: this.props.firstName, lastName: this.props.lastName, imageUrl: this.props.imageUrl }) }),
                React.createElement(Dropdown_1.default.Menu, null, this.props.children)));
        }
        else {
            return (React.createElement(Item_1.default, __assign({}, rest, { className: "user-profile-menu" }), React.createElement(ProfileIcon_1.default, { firstName: this.props.firstName, lastName: this.props.lastName, imageUrl: this.props.imageUrl })));
        }
    };
    UserProfile.Item = Item_1.default;
    return UserProfile;
}(react_1.Component));
exports.default = UserProfile;
